<app-auction-registeration-success
  [auctionId]="auctionInfo.id"
  [auctionName]="auctionInfo?.title"
  (goToBack)="goToRedirectUrl()"
  *ngIf="isRegistered"
>
</app-auction-registeration-success>

<div class="public-wrap" *ngIf="!isRegistered">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h3 class="register-name mb-3 pb-2">Register For The Auction</h3>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="auction-with-logo mb-3">
      <div class="left-logo">
        <img
          class="auction-logo"
          alt="auction-logo"
          AuctionDefaultImage
          *ngIf="auctionInfo"
          [image]="auctionInfo.clientLogo"
        />
      </div>
      <div class="right-logo">
        <div class="d-flex mb-2">
          <span class="card-badge no-card min-width-auto badge-dark">
            {{ auctionInfo?.saleType.publicName }}
          </span>
        </div>

        <h3 class="auc-name mb-2">{{ auctionInfo?.title }}</h3>
        <p class="auc-des mb-3" [innerHTML]="auctionInfo?.tagline"></p>
        <p class="auc-location mb-2">
          {{ auctionInfo?.auctionLocations | locationNames }}
        </p>
        <p
          class="auc-address m-0"
          [innerHtml]="
            auctionInfo?.saleType?.auctionDate
              | auctionDateFormat
                : auctionInfo?.auctionStatus
                : auctionInfo?.timeZoneName
                : auctionInfo?.startDateTime
                : auctionInfo?.endDateTime
                : auctionInfo?.saleType?.dateText
          "
        ></p>
      </div>
    </div>
  </div>

  <div class="container">
    <form [formGroup]="registerForm">
      <div class="to-register">
        <h1 class="register-hdg">
          To Register for this Auction please agree to the terms & conditions
          and click the "Register" button.
        </h1>
        <p class="register-des">
          You will receive an email notifying you of your eligibility to bid for
          this auction.
          <br />
          <br />
          This process can take upto 24 hours from the time you registered. We
          may contact you to verify your information and ask for a deposit
          before approving your registration. If you have registered on the day
          of the Auction we do make every effort to complete your registration
          as quickly as possible. In the future, we do suggest registering for
          our auctions atleast 48 hours before the day of the auction.
          <br />
          <br />
          If you have any questions, you can contact us at
          service@thebranfordgroup.com or call us at 203-488-7020.
        </p>

        <div class="spending-amount">
          <div class="form-group mb-4 no-float-fields">
            <label class="form-label"
              >How much are you interested in spending?
              <span class="fade-label">(optional)</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="number"
                inputmode="numeric"
                [min]="readyToSpentMinAmount"
                [max]="readyToSpentMaxAmount"
                formControlName="spending"
                [placeholder]="auctionInfo?.currencyName"
              />
            </mat-form-field>
            <control-messages
              [control]="registerForm.controls.spending"
            ></control-messages>
          </div>
        </div>

        <div class="register-terms" [innerHTML]="content"></div>

        <div class="registration-check">
          <div class="custom-checks-square check-grey">
            <input type="checkbox" formControlName="termsCheckBox" id="terms" />
            <label for="terms" class="m-0"
              >I agree to the
              <a target="_blank" routerLink="/term-and-conditions"
                >Terms & Conditions</a
              >
            </label>
          </div>
        </div>

        <div class="register-btns mt-4 pt-0 pt-md-3">
          <button
            type="submit"
            [disabled]="registerForm.invalid"
            class="btn btn-colored mr-2 mb-2 mb-md-0"
            role="button"
            (click)="onSubmit()"
          >
            Register
          </button>
          <button
            type="button"
            class="btn btn-white-border mb-2 mb-md-0"
            role="button"
            (click)="goToRedirectUrl()"
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
